import ContentEditDisplayEndDateDlg
  from "@/views/content/contentPublishedToDlg/contentEditDisplayEndDateDlg/contentEditDisplayEndDateDlg.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import firebase from "firebase";
import {serializer} from "@/api/shared/serializer";
import {DigitalSignagesTypes} from "@/enums/DigitalSignagesTypes";
import {DigitalSignageDateOptions} from "@/enums/DigitalSignageDateOptions";
import moment from "moment/moment";

export default {
  name: "contentPublishedToDlg",
  components: {
    ContentEditDisplayEndDateDlg,
    ConfirmDlg
  },
  data() {
    return {
      dialog: false,
      publishToDigitalSignage: [],
      selectedDigitalSignage: [],
      unPublishToDigitalSignage: [],
      selectedUnPublishDigitalSignage: [],
      selectedContent: null,
      isSelectedAll: false,
      isIndeterminate: false,
      search: "",
      searchDigitalSignage: "",
      loadingOnAdding: false
    }
  },
  computed: {
    publishToDigitalSignageSort() {
      return this.search
        ? this.publishToDigitalSignage.filter(signage => signage.digitalSignageName.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
        : this.publishToDigitalSignage;
    },
    unPublishToDigitalSignageSort() {
      return this.searchDigitalSignage
        ? this.unPublishToDigitalSignage.filter(signage => signage.digitalSignageName.toLowerCase().indexOf(this.searchDigitalSignage.toLowerCase()) !== -1)
        : this.unPublishToDigitalSignage;
    }
  },
  methods: {
    open(published, unpublished, contentCreator) {
      this.publishToDigitalSignage = published;
      this.unPublishToDigitalSignage = unpublished;
      this.selectedContent = contentCreator
      this.dialog = true
    },
    close() {
      this.publishToDigitalSignage = []
      this.selectedDigitalSignage = []
      this.dialog = false
    },
    selectAll() {
      if(this.isSelectedAll) {
        this.selectedDigitalSignage = this.publishToDigitalSignage.map(x => x.digitalSignageId);
      } else {
        this.selectedDigitalSignage = [];
      }
    },
    openEditDisplayEndDateDlg(signage) {
      this.$refs.contentEditDisplayEndDateDlg.open(signage);
    },
    openEditDisplayEndDateForMultipleDlg() {
      const signages = this.publishToDigitalSignage.filter(x => this.selectedDigitalSignage.includes(x.digitalSignageId));
      this.$refs.contentEditDisplayEndDateDlg.openForMultiple(signages);
    },
    filterAndReorder(items, filterFn) {
      return items
        .filter(filterFn)
        .map((item, index) => ({ ...item, order: index + 1 }));
    },
    async unPublishDigitalSignage(signage) {
      try {
        const response = await this.$refs.confirmDlg.open(null, this.$t('ContentPublishedToDlg.ContentUnPublishDigitalSignage'), false);
        if (!response || !response.agree) return;

        const query = await firebase.firestore().collection("digitalSignage").doc(signage.digitalSignageId).get();
        if (query.exists) {
          const data: any = serializer.documentSnapshotToDocument(query);
          const updatedPages = this.filterAndReorder(data.pages, page => page.contentCreatorId !== signage.contentCreatorId);

          await query.ref.update({ pages: updatedPages });

          this.$toast.open({
            message: this.$t("ContentPublishedToDlg.ContentDigitalSignageUnPublishedText"),
            type: 'success',
          });

          this.publishToDigitalSignage = this.filterAndReorder(this.publishToDigitalSignage, item => item.digitalSignageId !== signage.digitalSignageId);

          if(!this.unPublishToDigitalSignage.find(x => x.digitalSignageId === signage.digitalSignageId)) {
            this.unPublishToDigitalSignage.push({
              digitalSignageId: signage.digitalSignageId,
              digitalSignageName: signage.digitalSignageName,
            })
          }

          this.selectedDigitalSignage = this.selectedDigitalSignage.filter(x => x !== signage.digitalSignageId);

          await this.$store.dispatch("getDigitalSignages");
        }
      } catch (err) {
        this.$toast.open({
          message: this.$t("GeneralTranslations.UnhandledError"),
          type: 'error',
        });
        console.log(err.message);
      }
    },
    async unPublishMultipleDigitalSignage() {
      const signages = this.publishToDigitalSignage.filter(x => this.selectedDigitalSignage.includes(x.digitalSignageId));

      try {
        if(signages.length) {
          const response = await this.$refs.confirmDlg.open(null, this.$t('ContentPublishedToDlg.ContentUnPublishDigitalSignage'), false);
          if (!response || !response.agree) return;

          const updates = signages.map(async (signage) => {
            const query = await firebase.firestore().collection("digitalSignage").doc(signage.digitalSignageId).get();
            if (query.exists) {
              const data: any = serializer.documentSnapshotToDocument(query);
              const updatedPages = this.filterAndReorder(data.pages, page => page.contentCreatorId !== signage.contentCreatorId);

              await query.ref.update({ pages: updatedPages });

              this.publishToDigitalSignage = this.filterAndReorder(this.publishToDigitalSignage, item => item.digitalSignageId !== signage.digitalSignageId);

              if(!this.unPublishToDigitalSignage.find(x => x.digitalSignageId === signage.digitalSignageId)) {
                this.unPublishToDigitalSignage.push({
                  digitalSignageId: signage.digitalSignageId,
                  digitalSignageName: signage.digitalSignageName,
                })
              }

              this.selectedDigitalSignage = this.selectedDigitalSignage.filter(x => x !== signage.digitalSignageId);
            }
          })

          await Promise.all(updates);

          this.$toast.open({
            message: this.$t("ContentPublishedToDlg.ContentDigitalSignageUnPublishedText"),
            type: 'success',
          });

          await this.$store.dispatch("getDigitalSignages");
        }
      } catch (err) {
        this.$toast.open({
          message: this.$t("GeneralTranslations.UnhandledError"),
          type: 'error',
        });
        console.log(err.message);
      }
    },
    setNewExpirationDate(signage, expirationDate) {
      this.publishToDigitalSignage.forEach((x) => {
        if(x.digitalSignageId === signage.digitalSignageId) {
          x.hasExpirationDate = true;
          x.expirationDate = expirationDate;
        }
      });
    },
    clearSelectedSignages() {
      console.log("CLEAR MULTIPLE")
      this.selectedDigitalSignage = [];
      this.$forceUpdate();
    },
    async addContentToDigitalSignage() {
      this.loadingOnAdding = true;
      const addToPublished = [];

      const promises = this.selectedUnPublishDigitalSignage.map(async signageId => {
        try {
          const query = await firebase.firestore().collection("digitalSignage").doc(signageId).get();
          if (query.exists) {
            const data: any = serializer.documentSnapshotToDocument(query);
            const pages = data.pages;

            pages.push({
              contentCreatorId: this.selectedContent.id,
              type: DigitalSignagesTypes.ContentCreator,
              title: this.selectedContent.name,
              name: this.selectedContent.name,
              enabled: true,
              timeInSeconds: 10,
              url: "",
              order: pages.length + 1,
              displayDate: false,
              displayOn: DigitalSignageDateOptions.AllTheTime,
              displayForDays: [],
              startDate: moment(new Date()).format("YYYY-MM-DD"),
              time: {
                start: moment("09:00", "HH:mm").format(this.$store.state.facilityModule.selectedFacility.timeFormat),
                end: moment("17:00", "HH:mm").format(this.$store.state.facilityModule.selectedFacility.timeFormat)
              }
            });

            await query.ref.update({ pages: pages })
              .then(() => {
                const signage = this.unPublishToDigitalSignage.find(signage => signage.digitalSignageId === signageId)

                addToPublished.push({
                  hasExpirationDate: false,
                  enabled: true,
                  id: signageId,
                  name: this.selectedContent.name,
                  order: pages.length + 1,
                  type: DigitalSignagesTypes.ContentCreator,
                  title: this.selectedContent.name,
                  timeInSeconds: 10,
                  contentCreatorId: this.selectedContent.id,
                  url: "",
                  ...signage,
                })
              })
          }
        } catch (err) {
          return err;
        }
      });

      await Promise.all(promises)
        .then(() => {
          this.$toast.open({
            type: "success",
            message: this.$t("ContentPublishedToDlg.ContentDigitalSignageAddedText")
          });
        }).catch((err) => {
          this.showError(err);
        })

      this.publishToDigitalSignage.push(...addToPublished);
      this.unPublishToDigitalSignage = this.unPublishToDigitalSignage.filter(x => !this.selectedUnPublishDigitalSignage.includes(x.digitalSignageId));
      this.selectedUnPublishDigitalSignage = [];
      this.loadingOnAdding = false;
    },
    clearSelectedDigitalSignage() {
      this.selectedUnPublishDigitalSignage = [];
    },
    showError(err) {
      this.$toast.open({
        type: "error",
        message: err.message
      });
      console.log(err.message)
    }
  },
  watch: {
    selectedDigitalSignage(value) {
      if(value.length) {
        if(value.length === this.publishToDigitalSignage.length) {
          this.isSelectedAll = true;
        } else {
          this.isSelectedAll = false;
          this.isIndeterminate = true;
        }
      } else {
        this.isSelectedAll = false;
        this.isIndeterminate = false;
      }
    }
  }
}